(function () {
    'use strict';

    angular
        .module('app')
        .controller('tsunBulletinMoreController', tsunBulletinMoreController);

    function tsunBulletinMoreController(viewModel, $location, bulletinService) {
        var vm = this;
        vm.redirect = redirect;
        vm.getNoticeMoreList = getNoticeMoreList;

        let bulletinGetByPaggerDto = {
            menuSerilNo: '',
            bulletinTypeSerilNo: '',
            PaggerChoice: 1,
            noticePage: 1
        };


        onInit();

        function onInit() {
            vm.data = viewModel.data;
        }

        function redirect(bulletinSerilNo) {
            $location.path(`/tsu/bulletin/noticeDetail/${bulletinSerilNo}`).search('menu', getMenuQueryString());
        }

        function getNoticeMoreList() {
            bulletinGetByPaggerDto.noticePage++;
            //2為通知中心的意思
            bulletinGetByPaggerDto.dataType = 2;
            setSiteCode(bulletinGetByPaggerDto);
            bulletinService.getTsunMoreList(bulletinGetByPaggerDto).then(function (data) {
                vm.data.notices.bulletins = _.concat(vm.data.notices.bulletins, data.data.notices.bulletins);
                vm.data.hasNoticeMore = data.data.hasNoticeMore;
            });
        }

        function setSiteCode(bulletinParam) {
            switch (vm.type) {
                case 'bulletin':
                    bulletinParam.siteCode = enumService.siteCode.hrOutside;
                    break;
                case 'notice':
                    bulletinParam.siteCode = enumService.siteCode.tsunOut;
                    break;
            }
        }
    }
})();